import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"
import { weekdayNames } from 'app/@utils/dateLocale'

// value = identity ('0' = Monday .. '6' = Sunday); label = display in the active language
const WEEKDAY_VALUES = ['0', '1', '2', '3', '4', '5', '6']

export default function SelectWeekday({...props}) {
    const labels = weekdayNames('long')
    const options = WEEKDAY_VALUES.map((value, index) => ({ label: labels[index], value }))

    const myProps = {
        placeholder: i18n.t('common:filters.selectWeekdays'), label: i18n.t('common:filters.weekdaysLabel'),
        firstSelect: true, isClearable: true, options,
        icon: { icon: 'calendar-day' }, isMulti: true,
        ...props
    }

    return <SelectSeeker {...myProps} />
}